export class ForgotPasswordRequest {
  email: string;
}
